<div *ngIf="context.patientFiscalCode">
  <div class="row mt-3">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-6">
      <button class="w-100" itButton="primary" type="button" (click)="newRequest()">
        Crea Nuova Pratica
      </button>
    </div>
    <div class="col-6">
      <button class="w-100" itButton="primary" type="button" (click)="viewTransitions()">
        Visualizza Pratiche
      </button>
    </div>
  </div>
</div>
<div *ngIf="!context.patientFiscalCode">
  <h5>Nessun paziente. Impossibile effettuare alcuna operazione. Procedere nuovamente con il cambio di contesto.</h5>
</div>